export interface InternalServersConfigurationModel {
  _id: string;
  name: string;
  ipAddress: string;
  port: number;
  orgId: number;
  __v: number;
}

export interface InternalServersConfigurationReqModel {
  name?: string;
  ipAddress: string;
  port: number;
}

export enum InternalServerEnum {
  CastGateway = 'Cast_Gateway',
  RoomControlServer = 'Room_Control_Server'
}
